import React from 'react';
import './App.css';
import DropZone from './DropZone';
import SetUploader from './SetUploader';
import {worker} from './worker.js';
import WebWorker from './workerSetup';
import ProcessingCube from './ProcessingCube';
import { timingSafeEqual } from 'crypto';
import Visualizer from './Visualizer';
import Account from './Account';
import LoginDialog from './LoginDialog';
import DeviceLinkDialog from './DeviceLinkDialog';
import queryString from 'query-string';
import qrcode from 'qrcode';

class AppMobileUpload extends React.Component {
  worker = null;

  state = {
    sets: {},
    currentState: 'drop', // drop, analyzing, running, empty
    setsDone: [],
    setsErrored: [],
    qrCode: null,
    activeQrSet: null,
    qrLink: null,
    user: null,
    loginError: null,
    loginShown: false,
    deviceLinkShown: false,
    deviceLinkVerifying: false,
    cloudLinkCode: null,
    linkedSet: null
  }

  componentWillMount() {
    let params = queryString.parse(window.location.search);

    if ("linkedSet" in params) {
      qrcode.toDataURL(params.linkedSet, { scale: 8, errorCorrectionLevel: 'H' }, (err, url) => {
        this.setState({linkedQrCode: url});
      });

      const cloudLink = params.linkedSetCloudLink;
      this.setState({linkedSet: params.linkedSet, linkedSetCloudLink: cloudLink}, () => {
        fetch(cloudLink)
        .then(r => r.json())
        .then(j => {
          const metaUrl = cloudLink.slice(0, cloudLink.indexOf('.com/') + 4) + j.url + 'meta';
          const id = cloudLink.slice(cloudLink.lastIndexOf('/') + 1);
          fetch(metaUrl)
          .then(r => r.text())
          .then(r => {
            const intProperties = ['BitsAllocated', 'width', 'height', 'depth'];
            const metadata = {};
            r.split("\n").forEach(line => {
              const keyValue = line.split("=");
              metadata[keyValue[0]] = intProperties.indexOf(keyValue[0]) !== -1 ? parseInt(keyValue[1]) : keyValue[1];
            });
            const sets = this.state.sets;
            sets[id] = {
              uploadUrl: cloudLink,
              metaData: metadata
            };
            const setsDone = this.state.setsDone;
            setsDone.push(id);
            this.setState({sets, setsDone});
            this.setState({activeQrSet: id})
            this.propagateDeviceLinkSet(sets[id]);
          });
        });
      });
    }
  }

  propagateDeviceLinkSet(set) {
    if (!this.props.deviceLinkSocket) return;
    
    const metadata = set.metaData;
    const metaFile = [
      ["version", "1.1"]
    ].concat(Object.entries(metadata)).map(v => {
      return v.join('=');
    }).join("\n");

    this.props.deviceLinkSocket.emit('link_message', {
      token: this.props.device.token,
      msg: {
        type: 'set',
        url: set.downloadUrl,
        metadata: metadata,
        metaFile: metaFile,
        p2pConnection: this.props.p2pDataChannel && this.props.p2pDataChannel.readyState === "open" ? true : false,
      }
    });
  }

  resetWorker() {
    if (this.worker !== null) {
      this.worker.terminate();
      this.worker = null;
    }
  }

  itemsDropped(items) {
    this.reset();

    this.setState({
      currentState: 'analyzing',
      analyzeData: {totalFiles: items.length, leftFiles: items.length},
      timer: setInterval(() => {
        this.setState({analyzeData: this.state.analyzeData});
      }, 500)
    });

    console.time("Worker start");
    this.worker = new WebWorker(worker);
    console.timeEnd("Worker start");

    this.worker.addEventListener('message', e => {
      const m = e.data;
      if ("set" in m) {
        const newSets = Object.assign(this.state.sets);
        newSets[m.set] = m;

        this.setState({sets: newSets, currentSetId: m.set});
      }
      else if ("invalids" in m) {
        clearInterval(this.state.timer);

        if (Object.keys(this.state.sets).length === 0) {
          this.setState({
            currentState: 'empty'
          });
        }
        else {
          this.setState({
            currentState: 'running'
          });
        }
      }
      else if ("stat" in m) {
        this.setState({analyzeData: m.stat});
      }
    });

    this.worker.postMessage({items: items, fullPaths: items.map(i => i.fullPath)});
  }

  reset() {
    if (this.state.timer) clearInterval(this.state.timer);
    this.resetWorker();
    this.setState({
      sets: {},
      currentState: 'drop',
      setsDone: [],
      setsErrored: [],
      qrCode: null,
      analyzeData: null,
      timer: null
    });
  }

  setDone(id, state) {
    if (this.state.setsDone.indexOf(id) === -1) {
      this.state.sets[id].uploadUrl = state.uploadLink;
      this.state.sets[id].downloadUrl = state.downloadLink;
      this.setState({
        setsDone: this.state.setsDone.concat([id]),
        sets: this.state.sets
      });
      this.propagateDeviceLinkSet(this.state.sets[id]);
    }
  }

  setErrored(id) {
    if (this.state.setsErrored.indexOf(id) === -1) {
      this.setState({
        setsErrored: this.state.setsErrored.concat([id])
      });
    }
  }

  suppress(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  showQRCode(setId, qrCode, qrLink) {
    this.setState({qrCode, qrLink, activeQrSet: setId});
  }

  render() {
    const setIds = Object.keys(this.state.sets);
    const setUploaders = setIds.map(id => {
      return (<SetUploader id={id} key={id}
        user={this.state.user}
        p2pDataChannel={this.props.p2pDataChannel}
        linkConnectionState={this.props.linkConnectionState}
        downloadHost={this.props.uploaderEndpoint + ''}
        endPointUpload={this.props.uploaderEndpoint + '/upload'}
        endPointGetUploadId={this.props.uploaderEndpoint + '/getuploadid'}
        onOpenClick={(qrcode, link) => this.showQRCode(id, qrcode, link)}
        onDone={(state) => this.setDone(id, state)}
        onError={() => this.setErrored(id)}
        set={this.state.sets[id]}
        p2pConnectionInfo={this.props.p2pConnectionInfo}
        mobile={this.props.mobile} />);
    });
    const setCount = setIds.length;
    const allDone = this.state.setsErrored.length + this.state.setsDone.length >= setCount;
    const cancel = this.state.currentState === 'running' && !allDone;
    const activeQrSet = (this.state.sets[this.state.activeQrSet] || null);

    const analyzeData = this.state.analyzeData;
    const filesDone = analyzeData ? analyzeData.totalFiles - analyzeData.leftFiles : 0;
    const inFrame = this.props.framed || (window.location !== window.parent.location && !this.state.linkedSet);

    const linkedSetSliceCount = this.state.linkedSet ? (this.state.sets[this.state.activeQrSet] || {metaData: {depth: 1}}).metaData?.depth : 0;

    return (
      <div className={"App" + (this.props.framed ? ' framed' : '')  + ' ' + (inFrame ? ' inframe' : '') + (this.state.linkedSet ? ' linkedset' : '')} onDrag={this.suppress} onDragStart={this.suppress} onDragOver={this.suppress} onDragEnter={this.suppress} onDragLeave={this.suppress} onDragEnd={this.suppress}  onDrop={this.suppress}>
        {!inFrame && !this.state.linkedSet && <header className="App-header">
          {!inFrame && <img style={{display:'block', maxHeight: '3em', marginRight:'0.6em', height:'6vh'}} src="mhd-model.svg"/>}
          <h1>Medical Image Upload</h1>
        </header>}
        {this.props.mobile && this.state.linkedSet && <div id="main" className="App-body" style={{position:'relative', textAlign:'center', margin:'auto', display:'flex', flexDirection:'column'}}>
          <div style={{flex: 1, display: 'block'}}>
            <h3>Open dataset in Medicalholodeck</h3>
              {linkedSetSliceCount && <p><strong>{linkedSetSliceCount} slice{linkedSetSliceCount === 1 ? '' : 's'}</strong></p>}
              <p className="id" style={{maxWidth: '25em', whiteSpace: 'normal', margin:'auto'}}>{activeQrSet ? [activeQrSet.metaData.BodyPart, activeQrSet.metaData.Modality].filter(d => !!d).join(" – ") : ''}</p>
              <p style={{maxWidth: '20em', marginLeft: 'auto', marginRight: 'auto'}}>Proceed by scanning this QR-code with your mobile device:</p>
              <img src={this.state.linkedQrCode} style={{maxHeight:'40vh', margin:'auto'}}/>
          </div>
        </div>}
        {!this.state.linkedSet && <div id="main" className="App-body">
          {this.state.currentState === 'drop' && <div>
            {<div className="instructions">
              <p>Drag medical imaging data in DICOM format to use on your mobile device below. Your data will be automatically anonymized on your computer before the upload. You can upload several folders at the same time.<br/>
                {!this.props.framed && "After processing and uploading, scan the QR code with the mobile Medical Imaging XR app or connect your VR device with Device Link (Beta)."}
                {this.props.framed && "After processing and uploading, the datasets will appear in your VR device."}
                <br/>
                Read our full data protection information <a href="https://medicalholodeck.com/terms/privacy-policy/index.html" target="_blank">here</a>.
              </p>
            </div>}
            <DropZone dropZoneActive={this.props.dropZoneActive} itemsDropped={(files) => this.itemsDropped(files)} />
          </div>}
          {this.state.currentState === 'running' && <div>
            {setUploaders}
            <div>{cancel && <button style={{marginTop: '5vh'}} onClick={() => this.reset()}>Cancel</button>}
            {allDone && <button style={{marginTop: '5vh'}} onClick={() => this.reset()}>New Upload</button>}</div>
          </div>}
          {this.state.currentState === 'empty' && <div>
            <div>
            <h2>No DICOM sets found</h2>
            <p>Please select folders containing <strong>DICOM files</strong>.</p>
            <button style={{marginTop: '5vh'}} onClick={() => this.reset()}>New Upload</button></div></div>}
          {this.state.currentState === 'analyzing' && <div style={{textAlign:'center'}}><div>
            {analyzeData &&
              (analyzeData.leftFiles && <h4>Analyzing {analyzeData.totalFiles} files on your computer</h4> ||
              (analyzeData.leftSets && <h4>Anonymizing data on your computer</h4>))}
            {analyzeData.leftFiles && <div className="progress" style={{maxWidth:'400px', margin: 'auto'}}>
              <div className="progresscontainer">
                <div className="progressbar" style={{width: (((filesDone / analyzeData.totalFiles) || 0) * 100) + "%"}}></div>
                <div className="progresstext">{filesDone}/{analyzeData.totalFiles} read</div>
              </div>
            </div>}
            {analyzeData && analyzeData.leftSets && <h4>Building set #{analyzeData.leftSets}<span style={{opacity: (new Date().getSeconds() % 2 ? 0 : 1)}}>.</span></h4>}
            {(setCount > 0) && this.state.sets[this.state.currentSetId] && <div style={{margin:'auto', maxWidth:'20vw', display: 'flex', justifyContent: 'center', height:'20vh'}}>
              <Visualizer setId={this.state.currentSetId} set={this.state.sets[this.state.currentSetId]} />
            </div>}
            <button style={{marginTop: '5vh'}} onClick={() => this.reset()}>Cancel</button></div></div>}
        </div>}
        {this.props.mobile && !this.state.linkedSet && <a href="https://link.medicalholodeck.com" target="_blank"> 
          <button style={{marginBottom: '1em'}} className={"devicelinkbutton" + (this.state.linkedMhdClient ? ' linked' : '')}>
            <img style={{display:'inline-block', marginRight:'5px', height:'1.5em', verticalAlign:'middle'}} src="device-link.svg" /> {this.state.linkedMhdClient ? 'Linked (' + this.state.linkedMhdClient.name.replace('mhd-client', '') + ')' : 'Device Link'}
          </button>
         </a> }
        {this.props.mobile && <div className="App-footer">
          <div className="appstore-links" style={{display:'flex'}}>
            <a href="https://apps.apple.com/us/app/dicom-viewer-ar/id1477475516" target="blank"><img src="appstore-downloadpage-01-01-01.png" /></a>
            <a href="https://play.google.com/store/apps/details?id=com.medicalholodeck.dicomviewerar" target="blank"><img src="google-play-badge.png" /></a>
          </div>
          {!inFrame && <p><a href="https://medicalholodeck.com" target="_blank">Medicalholodeck.com</a></p>}
        </div>}
        {this.props.mobile && <div className={"qrwindow overlay" + (this.state.qrCode ? ' shown' : '')} onClick={() => this.setState({qrCode: null})}>
          <div className="inner" onClick={(e) => e.stopPropagation()}>
            <h3>Open dataset in Medicalholodeck</h3>
            <p><strong>{(this.state.sets[this.state.activeQrSet] || {}).length} slice{(this.state.sets[this.state.activeQrSet] || {}).length === 1 ? '' : 's'}</strong></p>
            <p className="id" style={{maxWidth: '25em', whiteSpace: 'normal', margin:'auto'}}>{activeQrSet ? [this.state.activeQrSet, activeQrSet.metaData.BodyPart, activeQrSet.metaData.Modality].filter(d => !!d).join(" – ") : ''}</p>
            <p style={{maxWidth: '20em', marginLeft: 'auto', marginRight: 'auto'}}>Proceed by scanning this QR-code with your mobile device:</p>
            <p><img src={this.state.qrCode} style={{maxWidth:'100%'}}/></p>
            <p>or open this link on your device:</p>
            <p className="link"><a href={this.state.qrLink} target="_blank">{this.state.qrLink}</a></p>
            <button onClick={(e) => { e.stopPropagation(); this.setState({qrCode: null}); }}>Close</button>
          </div>
        </div>}
      </div>
    );
  }
}

export default AppMobileUpload;
